import { NavLink, useLocation } from "react-router-dom";
import { Home, Trophy, Plus, Target, Award, Shield, ShoppingBag, Eye } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function BottomNav({ onNewSale }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const isObserver = user?.role === "observer";
  const loc = useLocation();

  // Observer: no "Vender" center button, no "Admin"
  const items = isObserver
    ? [
        { to: "/", icon: Home, label: "Início", testid: "nav-home" },
        { to: "/ranking", icon: Trophy, label: "Ranking", testid: "nav-ranking" },
        { to: "/loja", icon: ShoppingBag, label: "Loja", testid: "nav-store" },
        { to: "/missoes", icon: Target, label: "Missões", testid: "nav-missions" },
        { to: "/conquistas", icon: Eye, label: "Conquistas", testid: "nav-achievements" },
      ]
    : [
        { to: "/", icon: Home, label: "Início", testid: "nav-home" },
        { to: "/ranking", icon: Trophy, label: "Ranking", testid: "nav-ranking" },
        { to: "#new", icon: Plus, label: "Vender", testid: "nav-new-sale", action: true },
        isAdmin
          ? { to: "/missoes", icon: Target, label: "Missões", testid: "nav-missions" }
          : { to: "/loja", icon: ShoppingBag, label: "Loja", testid: "nav-store" },
        isAdmin
          ? { to: "/admin", icon: Shield, label: "Admin", testid: "nav-admin" }
          : { to: "/conquistas", icon: Award, label: "Conquistas", testid: "nav-achievements" },
      ];

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <div className="phone-frame">
        <div className="bottom-nav-inner grid grid-cols-5 px-2 py-2">
          {items.map((it) => {
            const Ico = it.icon;
            if (it.action) {
              return (
                <button
                  key={it.label}
                  data-testid={it.testid}
                  onClick={onNewSale}
                  className="flex flex-col items-center justify-center -mt-6"
                >
                  <span className="btn-arcade w-14 h-14 rounded-full flex items-center justify-center shadow-xl badge-pulse">
                    <Ico size={26} strokeWidth={2.6} />
                  </span>
                  <span className="text-[10px] mt-1 font-arcade text-white/90">{it.label}</span>
                </button>
              );
            }
            const active = loc.pathname === it.to;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                data-testid={it.testid}
                className="flex flex-col items-center justify-center py-2"
              >
                <Ico
                  size={22}
                  strokeWidth={2.2}
                  className={active ? "text-fuchsia-400" : "text-slate-400"}
                />
                <span
                  className={`text-[10px] mt-1 font-arcade ${
                    active ? "text-fuchsia-300" : "text-slate-500"
                  }`}
                >
                  {it.label}
                </span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
